import type { Board } from "../board";
import { PRIORITY_DEFAULT, type ParticleEmitter, type ProcessableThing } from "../interfaces";
import { ParticleType } from "../particleType";
import { PhysicalThing } from "../physicalThing";
import { randomInt } from "../random";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

const DUST_TURNS_MIN = 6;
const DUST_TURNS_MAX = 10;

export class DustEmitter extends PhysicalThing implements ParticleEmitter, ProcessableThing {
	static key = "DustEmitter";
	private turnsLeft = randomInt(DUST_TURNS_MIN, DUST_TURNS_MAX);

	constructor(xy: XY) {
		super(xy, false);
	}

	override isVisible(): boolean {
		return false;
	}

	override isTangible(): boolean {
		return false;
	}

	override getZOrder(): number {
		return ZOrder.AIR;
	}

	getParticleType(): ParticleType {
		return ParticleType.TORN_GROUND_DUST;
	}

	getParticleIntensity(): number {
		return Math.min(1, this.turnsLeft / DUST_TURNS_MAX);
	}

	processTurn(board: Board): void {
		this.turnsLeft--;
		if (this.turnsLeft <= 0) {
			board.removeAtEndOfTurn(this);
		}
	}

	getProcessPriority(): number {
		return PRIORITY_DEFAULT;
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), turnsLeft: this.turnsLeft };
	}

	static deserialize(data: any): DustEmitter {
		const e = new DustEmitter(deserializeXY(data.xy));
		e.visualId = data.visualId;
		e.turnsLeft = data.turnsLeft ?? DUST_TURNS_MIN;
		return e;
	}
}
